import { CALL_API } from '../middleware/api'

export const KEEPALIVE_SIGNALS_REQUEST = 'KEEPALIVE_SIGNALS_REQUEST'
export const KEEPALIVE_SIGNALS_SUCCESS = 'KEEPALIVE_SIGNALS_SUCCESS'
export const KEEPALIVE_SIGNALS_FAILURE = 'KEEPALIVE_SIGNALS_FAILURE'

export function fetchKeepAliveSignals(machineId) {
  const endDate = new Date()
  const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000)

  const params = `Machine=${machineId}&StartDate=${startDate.toISOString()}&EndDate=${endDate.toISOString()}`

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `keepalivesignals?${params}`,
      authenticated: true,
      types: [KEEPALIVE_SIGNALS_REQUEST, KEEPALIVE_SIGNALS_SUCCESS, KEEPALIVE_SIGNALS_FAILURE]
    }
  }
}
